import { useDispatch } from "react-redux";

import type { ButtonType } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { isDropdownOpenAction } from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";

type SignalsManagementButtonProps = { type?: ButtonType; onManageClick: () => void };

const SignalsManagementButton = ({ type = "primary", onManageClick }: SignalsManagementButtonProps) => {
    const dispatch = useDispatch();

    function handleManageClick() {
        dispatch(isDropdownOpenAction(true));
        onManageClick();
    }

    return (
        <IconButton
            dataAutomation="signals-management-button"
            iconName="settings"
            type={type}
            onClick={handleManageClick}
        >
            {translate("si.signals.dropdown.button.manage.text")}
        </IconButton>
    );
};

export default SignalsManagementButton;
